import React from 'react';
import ActivityCard from './ActivityCard';

export const ActivityList = ({ activities = [], onAddActivity }) => {
  if (!Array.isArray(activities)) {
    console.error('Activities is not an array:', activities);
    return (
      <div className="text-center text-gray-500">
        Error loading activities. Please try again later.
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="text-center text-gray-500">
        No activities available.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {activities.map((activity) => (
        <ActivityCard
          key={activity.name}
          activity={activity}
          onAdd={onAddActivity}
        />
      ))}
    </div>
  );
}; 